import { Dispatch, SetStateAction, useEffect, useState } from "react"
import { ChooseEditMode } from "./components"
import { TouchButton } from "./components/button"
import dayjs, { Dayjs } from "dayjs"
import { PickerProps } from "./components/modal/picker/types"
import { Box, Typography } from "@mui/material"
import { useContextState } from "../../../../hooks/theme"

type DateModalProps = {
    setIsToBiggerThanFrom: Dispatch<SetStateAction<boolean>>;
    buttonTitle: string;
    errorMsg?: string;
    defaultDate?: Dayjs | null;
    title: string;
    name: string;
    payload?: Omit<PickerProps, 'name'>;
    error?: boolean;
    timeZone: string
    clear?: boolean;
    getDate: (date: Dayjs) => void
    clearDate: () => void
    disable?: boolean
    minHeight?:number
}
const DateModalSimple = ({ clearDate, clear, title, minHeight, disable, name, timeZone, payload, error, defaultDate, errorMsg, buttonTitle, setIsToBiggerThanFrom, getDate }: DateModalProps) => {
    const [open, setOpen] = useState(false)
    const { colors } = useContextState()
    const [date, setDate] = useState<null | Dayjs>(defaultDate ?? null)
    const displayModal = () => {
        if (payload?.is?.end) {
            if (!date || dayjs(date).isBefore(dayjs(payload?.min))) {
                setDate(dayjs(payload.min))
            }
        }
        setOpen(() => true)
    }
    const cancel = () => {
        setOpen(() => false)
        setDate(defaultDate ?? null)
    }

    const getFormat = (date: Dayjs) => {
        setDate(date)
        getDate(date)
        cancel()
    }

    useEffect(() => {
        setDate(defaultDate ?? null)
        // if (defaultDate) {
        // }
    }, [defaultDate])
    return (
        <>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', width: '100%', gap: '5px' }}>
                <TouchButton clearDate={clearDate} clear={clear} minHeight={minHeight} title={buttonTitle} error={error} date={date} onClick={displayModal} disabled={disable ?? false} />

                {!!error && (<Typography sx={{ color: colors.color28, fontSize: '10px' }}>{errorMsg}</Typography>)}
            </Box>
            {open && (
                <ChooseEditMode
                    timeZone={timeZone}
                    setIsToBiggerThanFrom={setIsToBiggerThanFrom}
                    payload={payload}
                    defaultValue={date}
                    getFormat={getFormat}
                    title={title}
                    cancel={cancel}
                    open={open}
                    name={name}
                />
            )}
        </>
    )
}

export { DateModalSimple }
